






















































































import mixins from 'vue-typed-mixins'
import AbstractScriptRow from '../abstract'
import Collapse from '@/components/Collapse/Collapse.vue'

interface Data {
  isCollapsed: boolean
}

interface Methods {
  handleToggleCollapse: () => void
}

export default mixins(AbstractScriptRow).extend<Data, Methods, {}, {}>({
  components: {
    Collapse,
  },
  data() {
    return {
      isCollapsed: true,
    }
  },
  methods: {
    handleToggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
  },
})
